import { FC } from "react";

import { INDEX_NOT_FOUND } from "components/constants";
import {
  INTERACTION_MODE_CHIP_KINDS,
  INTERACTION_MODE_ICONS,
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE,
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW,
} from "components/materials/page/interaction-mode/helpers";
import { InteractionMode, PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { Chip, ChipKind } from "mds/components/Chip";
import { IconText } from "mds/components/IconText";
import { GROUP_INTERACTION_MODES } from "utils/page-utils";

interface StudentInteractionModeView {
  pageGroupIndex: number;
  page: PageType;
  onStudentGroupCardToggle?: () => void;
}

export const StudentInteractionModeView: FC<StudentInteractionModeView> = ({
  page,
  pageGroupIndex,
  onStudentGroupCardToggle,
}) => {
  if (GROUP_INTERACTION_MODES.includes(page.interaction_mode)) {
    const iconText = (
      <IconText
        className="gap-1.5"
        containerQueryClassNameHide={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE}
        containerQueryClassNameShow={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW}
        iconStart={INTERACTION_MODE_ICONS[page.interaction_mode]}
        text={
          pageGroupIndex === INDEX_NOT_FOUND
            ? t("page_interaction_mode_menu.interaction_mode.self_assign")
            : t("common.group_title", {
                number: pageGroupIndex + 1,
              })
        }
      />
    );

    if (onStudentGroupCardToggle) {
      return (
        <Button
          kind="chipHibiscus"
          size="xs"
          title={t("tooltip.type_of_activity")}
          onClick={onStudentGroupCardToggle}
        >
          {iconText}
        </Button>
      );
    }

    return (
      <Chip kind={INTERACTION_MODE_CHIP_KINDS[page.interaction_mode] as ChipKind}>{iconText}</Chip>
    );
  }

  if (page.interaction_mode === InteractionMode.SHARED_CLASS) {
    return (
      <Chip kind={INTERACTION_MODE_CHIP_KINDS[page.interaction_mode] as ChipKind}>
        <IconText
          className="gap-1.5"
          containerQueryClassNameHide={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE}
          containerQueryClassNameShow={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW}
          iconStart={INTERACTION_MODE_ICONS[page.interaction_mode]}
          shortText={t("page_interaction_mode_menu.interaction_mode.all_short")}
          text={t("page_interaction_mode_menu.interaction_mode.all")}
        />
      </Chip>
    );
  }

  if (page.interaction_mode === InteractionMode.INDIVIDUAL) {
    return (
      <Chip kind={INTERACTION_MODE_CHIP_KINDS[page.interaction_mode] as ChipKind}>
        <IconText
          className="gap-1.5"
          containerQueryClassNameHide={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE}
          containerQueryClassNameShow={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW}
          iconStart={INTERACTION_MODE_ICONS[page.interaction_mode]}
          text={t("page_interaction_mode_menu.interaction_mode.individual")}
        />
      </Chip>
    );
  }

  return null;
};
